import styled from "@emotion/styled";
import DatePicker from "react-datepicker";

const InputHidedDatePicker = styled(DatePicker)`
  display: none !important;
`

export default InputHidedDatePicker;